import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { adminApi, CHECKIN, Badge } from "./adminApi";
import { ClosuresPanel } from "./ClosuresPanel";
import { BookingDrawer } from "./BookingDrawer";

const iso = (d) => d.toLocaleDateString("sv-SE");
const mondayOf = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); x.setDate(x.getDate() - ((x.getDay() + 6) % 7)); return x; };
const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

export const CalendarTab = () => {
  const [start, setStart] = useState(mondayOf(new Date()));
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => { adminApi.get("/admin/calendar", { params: { start: iso(start) } }).then(({ data }) => setItems(data)); }, [start]);

  const days = Array.from({ length: 7 }, (_, i) => addDays(start, i));
  const today = iso(new Date());
  const range = `${days[0].toLocaleDateString("it-IT", { day: "numeric", month: "long" })} – ${days[6].toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}`;

  return (
    <div data-testid="calendar-tab">
      <div className="flex items-center justify-between gap-4">
        <p className="f-serif text-3xl text-[#1B3B28]" data-testid="calendar-range">{range}</p>
        <div className="flex gap-2">
          <button onClick={() => setStart(addDays(start, -7))} data-testid="calendar-prev-btn" aria-label="Settimana precedente" className="w-10 h-10 grid place-items-center rounded-full border border-[#1B3B28]/15 text-[#1B3B28] hover:bg-[#E6ECE4]"><ChevronLeft size={18} /></button>
          <button onClick={() => setStart(mondayOf(new Date()))} data-testid="calendar-today-btn" className="rounded-full border border-[#1B3B28]/15 px-4 text-sm text-[#1B3B28] hover:bg-[#E6ECE4]">Oggi</button>
          <button onClick={() => setStart(addDays(start, 7))} data-testid="calendar-next-btn" aria-label="Settimana successiva" className="w-10 h-10 grid place-items-center rounded-full border border-[#1B3B28]/15 text-[#1B3B28] hover:bg-[#E6ECE4]"><ChevronRight size={18} /></button>
        </div>
      </div>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-7 gap-3">
        {days.map((d) => {
          const key = iso(d);
          const list = items.filter((b) => b.appointment_date === key);
          return (
            <div key={key} className={`rounded-[1.5rem] p-3 min-h-[180px] ${key === today ? "bg-[#1B3B28]/[0.06] ring-1 ring-[#86C89B]" : "bg-[#FCFBF7] border border-[#1B3B28]/8"}`} data-testid={`calendar-day-${key}`}>
              <p className="text-xs text-[#526356] capitalize">{d.toLocaleDateString("it-IT", { weekday: "long" })}</p>
              <p className="f-serif text-3xl text-[#1B3B28] leading-none mt-1">{d.getDate()}</p>
              <div className="mt-3 space-y-2">
                {list.map((b) => (
                  <button key={b.id} onClick={() => setOpen(b)} data-testid={`calendar-item-${b.id}`}
                    className={`w-full text-left rounded-xl px-3 py-2 transition-colors ${b.laser_session ? "bg-[#1B3B28] text-[#FCFBF7] hover:bg-[#3E6B48]" : "bg-[#E6ECE4] text-[#1B3B28] hover:bg-[#D5DFD3]"}`}>
                    <p className="f-mono text-[11px] opacity-80">{b.appointment_time}{b.laser_session && " · laser"}{b.trattamento === "igiene_gbt" && " · GBT"}</p>
                    <p className="text-sm leading-tight mt-0.5">{b.nome} {b.cognome}</p>
                    {b.checkin_response && <span className="block mt-1"><Badge cls={CHECKIN[b.checkin_response].cls}>{CHECKIN[b.checkin_response].label}</Badge></span>}
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      <BookingDrawer booking={open} onClose={() => setOpen(null)} />
      <ClosuresPanel />
    </div>
  );
};
